import Image from 'next/image'
import cn from 'classnames'
import { Image as ImageType } from '@mc/api'
import { IconCheckDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { CertificateSignupCTA } from 'pages/certificates/common/CertificateSignupCTA'
import classes from './CertificateSection.module.scss'

const Item = ({ children }: { children: string }) => (
  <li className='c-my-4'>
    <div className='d-flex'>
      <IconCheckDefault className='c-text-color--brand-highlight c-mr-3 flex-none c-mt-1' />
      {children}
    </div>
  </li>
)

export const CertificateSignupChecklist = () => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <ul>
      <Item>{t('marketingPages.certificate.certificateSection.item1')}</Item>
      <Item>{t('marketingPages.certificate.certificateSection.item2')}</Item>
      <Item>{t('marketingPages.certificate.certificateSection.item3')}</Item>
    </ul>
  )
}

type CertificateSectionProps = {
  image?: ImageType
  subtext?: string
}

export const CertificateSection = ({
  image,
  subtext,
}: CertificateSectionProps) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <div className={cn('container', classes.container)}>
      <div
        className='d-flex flex-column flex-md-row mc-corners--6 c-bg-base-1400 c-text-color--light c-mt-11'
        style={{ overflow: 'hidden' }}
      >
        {image && (
          <div className={cn('position-relative', classes.imageContainer)}>
            <Image
              src={image?.url || ''}
              alt={image?.altText || ''}
              fill
              style={{
                objectFit: 'cover',
              }}
            />
          </div>
        )}
        <div className='flex-1 d-flex flex-column c-px-5 c-px-lg-8 c-py-9 align-items-center align-items-md-start'>
          <h3 className='c-text-color--tint-1 c-caption-mono c-mb-7'>
            {t('marketingPages.certificate.certificateSection.preTitle')}
          </h3>
          <h2
            className='c-d-1 c-text-ivar-display-condensed c-mb-7'
            style={{ maxWidth: '18ch' }}
          >
            {t('marketingPages.certificate.certificateSection.title')}
          </h2>
          <CertificateSignupChecklist />
          <div className='d-flex flex-column c-mt-7 align-items-center'>
            <CertificateSignupCTA subtext={subtext} />
          </div>
        </div>
      </div>
    </div>
  )
}
